// Esencia de Anais — interacciones compartidas
(function () {
  // Email protegido: reconstruye la dirección para el cliente real
  // (los bots solo ven el email partido y sin "mailto:" en el HTML).
  document.querySelectorAll('.email-protegido').forEach(function (el) {
    var user = el.getAttribute('data-user');
    var domain = el.getAttribute('data-domain');
    if (!user || !domain) return;
    var direccion = user + '@' + domain;
    var enlace = document.createElement('a');
    enlace.href = 'mailto:' + direccion;
    enlace.textContent = direccion;
    el.parentNode.replaceChild(enlace, el);
  });

  // Menú móvil
  var btn = document.querySelector('.btn-menu');
  var nav = document.querySelector('.principal');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      nav.classList.toggle('abierto');
    });
  }

  // Submenús desplegables en móvil (acordeón)
  var esMovil = function () { return window.matchMedia('(max-width: 760px)').matches; };
  function alternarSubmenu(item, boton) {
    var abierto = item.classList.toggle('abierto');
    if (boton) boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  }
  document.querySelectorAll('.nav-item--desplegable').forEach(function (item) {
    var boton = item.querySelector('.nav-toggle');
    var enlace = item.querySelector('.nav-enlace');
    if (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        alternarSubmenu(item, boton);
      });
    }
    // En móvil, tocar el nombre de la categoría abre/cierra el submenú
    // (los enlaces reales son las subcategorías). En escritorio navega normal.
    if (enlace) {
      enlace.addEventListener('click', function (e) {
        if (esMovil()) {
          e.preventDefault();
          alternarSubmenu(item, boton);
        }
      });
    }
  });

  // Carrusel de testimonios — cinta continua (marquee)
  // El movimiento lo hace una animación CSS infinita. Aquí solo duplicamos
  // las tarjetas una vez para que el bucle no tenga saltos: la animación
  // recorre el primer juego y, al volver a 0, el segundo juego ya está en
  // la misma posición visual.
  var carrusel = document.querySelector('.testimonios-carrusel');
  if (carrusel) {
    var pista = carrusel.querySelector('.testimonios-pista');
    var originales = pista.querySelectorAll('.testimonio');
    if (originales.length) {
      originales.forEach(function (tarjeta) {
        var clon = tarjeta.cloneNode(true);
        clon.setAttribute('aria-hidden', 'true');
        pista.appendChild(clon);
      });
    }
  }

  // Aparición al hacer scroll
  var observados = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && observados.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    observados.forEach(function (el) { io.observe(el); });
  } else {
    observados.forEach(function (el) { el.classList.add('in'); });
  }
})();
